import { useEffect } from 'react';

import { useFacebookIntegration, useGoogleIntegration, useShopifyIntegrationDestination, useTikTokIntegrationDestination } from '@/features/destinations/hooks/use-destination-by-type';
import { usePixelDestinations } from '@/hooks/account/use-pixel-destinations';
import { usePixelDestinationsLoading } from '@/features/workspace/providers/account-stores-context';
import useStore from '@/store/app/use-store';

export function useIntegrationData() {
  const destinations = usePixelDestinations();
  const onChangeIntegrationsStore = useStore(s => s.onChangeIntegrationsStore);

  // Destinations are fetched by AccountStoresProvider; get loading/refetch from context
  const { isLoading, refetch } = usePixelDestinationsLoading();

  const facebookIntegration = useFacebookIntegration();
  const googleIntegration = useGoogleIntegration();
  const shopifyIntegration = useShopifyIntegrationDestination();
  const tiktokIntegration = useTikTokIntegrationDestination();

  useEffect(() => {
    onChangeIntegrationsStore?.({
      isFacebookLoggedIn: !!facebookIntegration?.enabled,
      googleIsLoggedIn: !!googleIntegration?.enabled,
    });
  }, [facebookIntegration?.enabled, googleIntegration?.enabled, onChangeIntegrationsStore]);

  return {
    facebookIntegration,
    googleIntegration,
    shopifyIntegration,
    tiktokIntegration,
    destinations,
    isLoading,
    refetch,
  };
}
